// Foundations
import { Component, Input, OnInit } from '@angular/core';

// Models
import { FranchiseLocation } from 'src/app/models/franchise.model';

@Component({
  selector: 'app-landing-location',
  templateUrl: './landing-location.component.html',
  styleUrls: ['./landing-location.component.scss'],
})
export class LandingLocationComponent implements OnInit {
  @Input() locationTileList: FranchiseLocation[];

  constructor() {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {}
}
